import { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'

function initialOf(user) {
  const source = user?.displayName || user?.email || '?'
  return source.trim().charAt(0).toUpperCase()
}

// Avatar button that opens a small dropdown (identity + log out).
function AccountMenu() {
  const { user, logout } = useAuth()
  const navigate = useNavigate()
  const [open, setOpen] = useState(false)
  const ref = useRef(null)

  useEffect(() => {
    if (!open) return undefined
    const onClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', onClick)
    return () => document.removeEventListener('mousedown', onClick)
  }, [open])

  const handleLogout = async () => {
    setOpen(false)
    await logout()
    navigate('/')
  }

  return (
    <div className="account-menu" ref={ref}>
      <button
        type="button"
        className="account-avatar"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        {initialOf(user)}
      </button>

      {open && (
        <div className="account-dropdown" role="menu">
          <div className="account-identity">
            <div className="account-name">{user?.displayName || 'Account'}</div>
            <div className="account-email">{user?.email}</div>
          </div>
          <button
            type="button"
            className="account-item"
            role="menuitem"
            onClick={handleLogout}
          >
            Log out
          </button>
        </div>
      )}
    </div>
  )
}

export default AccountMenu
